import { render, staticRenderFns } from "./FTab1.vue?vue&type=template&id=7a06d427&scoped=true&"
import script from "./FTab1.vue?vue&type=script&lang=js&"
export * from "./FTab1.vue?vue&type=script&lang=js&"
import style0 from "./FTab1.vue?vue&type=style&index=0&id=7a06d427&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06d427",
  null
  
)

export default component.exports